import { useCurrentEditor } from '@tiptap/react';
import { CommandEmpty, CommandItem } from 'cmdk';
import { observer } from 'mobx-react-lite';
import { forwardRef, type ComponentPropsWithoutRef } from 'react';

import { editorStore } from '../utils/editor.store';

import type { Editor, Range } from '@tiptap/core';

interface EditorCommandItemProps {
  readonly onCommand: ({
    editor,
    range,
  }: {
    editor: Editor;
    range: Range;
  }) => void;
}

export const EditorCommandItem = observer(
  forwardRef<
    HTMLDivElement,
    EditorCommandItemProps & ComponentPropsWithoutRef<typeof CommandItem>
  >(({ children, onCommand, ...rest }, ref) => {
    const { editor } = useCurrentEditor();
    const range = editorStore.range;

    if (!editor || !range) return null;

    return (
      <CommandItem
        ref={ref}
        {...rest}
        onSelect={() => onCommand({ editor, range })}
      >
        {children}
      </CommandItem>
    );
  })
);

EditorCommandItem.displayName = 'EditorCommandItem';

export const EditorCommandEmpty = CommandEmpty;
